import React from 'react'
import { useParams } from 'react-router-dom'
import { AuthorProductionWrapper } from '../components/qr/AuthorProductionWrapper'

export default function AuthorProfilePage() {
  const { slug, accountSlug } = useParams<{ slug: string; accountSlug?: string }>()
  
  return (
    <div className="h-screen">
      <AuthorProductionWrapper 
        linkId={slug}
        accountSlug={accountSlug}
        isPreview={false}
      />
    </div>
  )
}
